import React, { useState, useEffect, useRef } from "react";
import "./Products.css";
import ProductComponent from "./Products";
import ProductArComponent from "./ProductsAr";
import { useLocation } from "react-router-dom";
import HomeS2Active from "../../../Assets/Svg/Home/HomeS2Active.svg";
import HomeS2NotActive from "../../../Assets/Svg/Home/HomeS2NotActive.svg";
export default function ProductsSliderRight({ products, speed = 30, stepSize = 2 }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const [offset, setOffset] = useState(0);
  const sliderRef = useRef(null);
  const animationFrameRef = useRef(null);
  const lastTimestampRef = useRef(0);

  // For Mobile
  const isMobile = window.innerWidth <= 768;
  const [activeIndex, setActiveIndex] = useState(0); // For mobile navigation
  const [isSwiping, setIsSwiping] = useState(false);
  const [startX, setStartX] = useState(0);
  // Update the position of the slider
  const updatePosition = (timestamp) => {
    if (!sliderRef.current) return; // Guard against null
    if (!lastTimestampRef.current) {
      lastTimestampRef.current = timestamp;
    }

    const deltaTime = timestamp - lastTimestampRef.current;

    // Move the slider based on elapsed time
    if (deltaTime >= speed) {
      setOffset((prevOffset) => {
        const containerWidth = sliderRef.current.scrollWidth / 2;
        return prevOffset <= 0 ? containerWidth : prevOffset - stepSize;
      });
      lastTimestampRef.current = timestamp;
    }

    animationFrameRef.current = requestAnimationFrame(updatePosition);
  };

  // Start the animation
  const startAnimation = () => {
    if (!animationFrameRef.current) {
      animationFrameRef.current = requestAnimationFrame(updatePosition);
    }
  };

  // Stop the animation
  const stopAnimation = () => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }
  };

  // Handle tab visibility change
  const handleVisibilityChange = () => {
    if (document.hidden) {
      stopAnimation();
    } else {
      startAnimation();
    }
  };

  useEffect(() => {
    if (!isMobile) {
      startAnimation();
      document.addEventListener("visibilitychange", handleVisibilityChange);

      return () => {
        stopAnimation();
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    }
  }, [speed, stepSize, isMobile]);
  // Handle hover events
  const handleMouseEnter = () => stopAnimation();
  const handleMouseLeave = () => startAnimation();

  const Product = isArabic ? ProductArComponent : ProductComponent;

  //
  // For Mobile
  //

  const handleSwipe = (direction) => {
    if (direction === "left") {
      setActiveIndex((prevIndex) => (prevIndex + 1) % products.length);
    } else if (direction === "right") {
      setActiveIndex((prevIndex) => (prevIndex === 0 ? products.length - 1 : prevIndex - 1));
    }
  };

  // Handle touch start
  const handleTouchStart = (e) => {
    setIsSwiping(true);
    setStartX(e.touches[0].clientX); // Get the initial touch position
  };

  // Handle touch move
  const handleTouchMove = (e) => {
    if (!isSwiping) return;

    const touchDelta = e.touches[0].clientX - startX;
    if (touchDelta > 50) {
      handleSwipe("right");
      setIsSwiping(false); // Prevent multiple swipes
    } else if (touchDelta < -50) {
      handleSwipe("left");
      setIsSwiping(false); // Prevent multiple swipes
    }
  };

  // Handle touch end
  const handleTouchEnd = () => {
    setIsSwiping(false);
  };

  const handleDotClick = (index) => setActiveIndex(index);
  const activeImage = HomeS2Active;
  const nonActiveImage = HomeS2NotActive;
  const sortedProducts = [...products].sort((a, b) => {
    if (isMobile) {
      return (a.orderMobile || 0) - (b.orderMobile || 0);
    }
    return (a.orderWeb || 0) - (b.orderWeb || 0);
  });

  if (isMobile) {
    const sortedProducts = [...products].sort((a, b) => a.orderMobile - b.orderMobile);

    return (
      <div className="Product_Slider_Mob" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
        <div className="product-active-mobile">
          <Product
            ProductName={sortedProducts[activeIndex].ProductName}
            NameFSize={sortedProducts[activeIndex].NameFSize}
            NameTop={sortedProducts[activeIndex].NameTop}
            NameLeft={sortedProducts[activeIndex].NameLeft}
            ImgSrc={sortedProducts[activeIndex].ImgSrc}
            ImgAlt={sortedProducts[activeIndex].ImgAlt}
            ProductWeight={sortedProducts[activeIndex].ProductWeight}
            NutritionName={sortedProducts[activeIndex].NutritionName}
            NutritionItems={sortedProducts[activeIndex].NutritionItems}
          />
        </div>
        <div className="dots-navigation-mobile">
          {sortedProducts.map((_, index) => (
            <img key={index} src={index === activeIndex ? activeImage : nonActiveImage} alt="" className={index === activeIndex ? "active" : "non-active"} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="products_slider_wrapper" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <div className="products_slider_container" ref={sliderRef} style={{ transform: `translateX(-${offset}px)` }}>
          {sortedProducts.concat(sortedProducts).map((product, index) => (
            <Product key={index} {...product} />
          ))}
        </div>
      </div>
    </>
  );
}
